import type { JSX } from 'react';

import { MessageText } from '../lia/messageText.js';
import { libelleDeMention, segmentsDeTexte, type EntreeDeMention } from './mentions.js';
import { AUTEUR_LIA } from './port.js';
import { TexteAvecMentions } from './TexteAvecMentions.js';

/**
 * LE TEXTE STOCKE D'UNE MENTION EN CLAIR (« @[p-marc] » devient « @Marc ») :
 * le texte qu'une reponse de Lia donne a lire au rendu Markdown, qui ne sait
 * rien des jetons. Exporte pour le test.
 */
export function texteAvecMentionsEnClair(texte: string, entrees: readonly EntreeDeMention[]): string {
  return segmentsDeTexte(texte).map((segment) => (segment.type === 'texte' ? segment.valeur : libelleDeMention(segment, entrees))).join('');
}

/**
 * LE TEXTE D'UN MESSAGE DE CONVERSATION, selon son auteur (ecart 11 de la
 * verification du soir). Une reponse de LIA a le rendu de la fenetre de
 * communication (`MessageText`, `packages/ui/src/lia/` : Markdown, listes,
 * gras, tableaux), et non son Markdown brut ; le message d'une PERSONNE garde
 * le sien, texte et pastilles de mentions cliquables (`TexteAvecMentions`).
 * Un seul composant pour le fil du socle (`FilDeConversation`) et pour l'app
 * Canaux : aucune copie du rendu.
 */
export function TexteDuMessage({
  texte,
  auteur,
  entrees,
  moi,
  className,
}: {
  texte: string;
  auteur: string | undefined;
  entrees: readonly EntreeDeMention[];
  moi?: string | null | undefined;
  className?: string;
}): JSX.Element {
  if (auteur === AUTEUR_LIA) {
    return <div data-texte-lia className={className}><MessageText text={texteAvecMentionsEnClair(texte, entrees)} /></div>;
  }
  return <TexteAvecMentions texte={texte} entrees={entrees} moi={moi} {...(className !== undefined ? { className } : {})} />;
}
